// Content data for the advertorial landing page (user-owned advertorial content)

export const advertorialData = {
  label: "Advertorial - AI-assisted content",
  headline: "The Market Is Rigged... Here's How...",
  heroImage: {
    src: "/images/hero-rigged-market.jpg",
    alt: "Traders looking at a rigged market illustration"
  },
  author: "The Matrix Unlocked",
  date: "August 3, 2026",
  ctaLinks: {
    main: "https://thematrixunlocked.com/",
    typeform: "https://thematrixunlocked.com/application",
    about: "https://thematrixunlocked.com/about",
    privacy: "https://thematrixunlocked.com/privacy-policy",
    terms: "https://thematrixunlocked.com/terms"
  },
  images: {
    algorithms: {
      src: "/images/smart-money-algorithms.jpg",
      alt: "Smart Money algorithms"
    },
    signatures: {
      src: "/images/algorithmic-signatures.jpg",
      alt: "Algorithmic signatures on charts"
    },
    collective: {
      src: "/images/matrix-unlocked-collective.jpg",
      alt: "The Matrix Unlocked traders collective"
    }
  },
  footer: {
    copyright: "© 2026 Copyright",
    brand: "The Matrix Unlocked",
    rights: "All rights reserved."
  }
};
